<div class="invoice-page">
  <div class="header">
    <h2>Sales Invoice Management</h2>
  </div>

  <div class="invoice-content">
    <div class="tab-navigation">
      <button class="tab-btn" [class.active]="activeTab === 'invoices'"
        (click)="switchTab('invoices')">Invoices</button>
      <button class="tab-btn" [class.active]="activeTab === 'items'" (click)="switchTab('items')">Invoice Items</button>
    </div>

    <!-- Invoices Tab -->
    <div *ngIf="activeTab === 'invoices'">
      <!-- Toolbar -->
      <div class="toolbar-container" style="justify-content: space-between; align-items: flex-end;">
        <!-- Filters (Optional, can be expanded) -->
        <div class="selection-container" style="width: 300px;">
          <label for="company-filter">Filter by Company</label>
          <select id="company-filter" [(ngModel)]="filterCompanyId" (ngModelChange)="applyFilters()"
            class="period-select">
            <option value="">All Companies</option>
            <option *ngFor="let c of companies" [value]="c.id">{{ c.company }}</option>
          </select>
        </div>
        <div>
          <button class="action-btn save-btn" (click)="openAddInvoiceModal()">+ Add Sales Invoice</button>
        </div>
      </div>

      <!-- Main Data Grid -->
      <div class="data-grid-container" style="margin-top: 20px;">
        <div class="data-grid-scrollable">
          <table class="data-grid">
            <thead>
              <tr>
                <th (click)="sortBy('status')" style="cursor: pointer; user-select: none;">
                  Status <span *ngIf="sortColumn === 'status'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
                </th>
                <th (click)="sortBy('emailStatus')" style="cursor: pointer; user-select: none;">
                  Sent <span *ngIf="sortColumn === 'emailStatus'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
                </th>
                <th (click)="sortBy('invoiceDate')" style="cursor: pointer; user-select: none;">
                  Date <span *ngIf="sortColumn === 'invoiceDate'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
                </th>
                <th (click)="sortBy('invoiceNumber')" style="cursor: pointer; user-select: none;">
                  Invoice # <span *ngIf="sortColumn === 'invoiceNumber'">{{ sortDirection === 'asc' ? '↑' : '↓'
                    }}</span>
                </th>
                <th (click)="sortBy('company')" style="cursor: pointer; user-select: none;">
                  Company <span *ngIf="sortColumn === 'company'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
                </th>
                <th class="text-right" (click)="sortBy('totalDue')" style="cursor: pointer; user-select: none;">
                  Total Due (USD) <span *ngIf="sortColumn === 'totalDue'">{{ sortDirection === 'asc' ? '↑' : '↓'
                    }}</span>
                </th>
                <th class="text-right" (click)="sortBy('remainingBalance')" style="cursor: pointer; user-select: none;">
                  Rem. Balance (USD) <span *ngIf="sortColumn === 'remainingBalance'">{{ sortDirection === 'asc' ? '↑' :
                    '↓' }}</span>
                </th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="isLoadingGrid">
                <td colspan="8" class="text-center loading-row">
                  <div class="loading-content">
                    <div class="spinner spinner-sm"></div>
                    <span>Loading data...</span>
                  </div>
                </td>
              </tr>
              <ng-container *ngIf="!isLoadingGrid">
                <ng-container *ngFor="let row of filteredGridData">
                  <tr class="data-row" (click)="expandedRowId = expandedRowId === row.id ? null : row.id"
                    [class.expanded-row]="expandedRowId === row.id">
                    <td>
                      <span class="status" [class.status-paid]="row.status === 'Paid'"
                        [class.status-partial]="row.status === 'Partial'"
                        [class.status-not-paid]="row.status === 'Not Paid'"
                        [class.status-canceled]="row.status === 'Canceled'">
                        {{ row.status }}
                      </span>
                    </td>
                    <td>
                      <span class="status" [class.status-sent]="row.emailStatus === 'Sent'"
                        [class.status-not-sent]="row.emailStatus !== 'Sent'">
                        {{ row.emailStatus }}
                      </span>
                    </td>
                    <td>{{ row.invoiceDate | date:'mediumDate' }}</td>
                    <td>{{ row.invoiceNumber }}</td>
                    <td>{{ row.company?.company || 'Unknown' }}</td>
                    <td class="text-right">{{ row.totalDue | currency }}</td>
                    <td class="text-right">{{ row.remainingBalance | currency }}</td>
                    <td class="company-actions text-center">
                      <button class="action-btn view-btn" (click)="$event.stopPropagation(); viewInvoice(row)"
                        title="View Invoice">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14 2 14 8 20 8"></polyline>
                          <circle cx="10" cy="14" r="3"></circle>
                          <path d="m12.1 16.1 2.9 2.9"></path>
                        </svg>
                      </button>
                      <button class="action-btn email-btn" (click)="$event.stopPropagation(); emailSingleInvoice(row)"
                        title="Email Invoice">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                          <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                      </button>
                      <button class="action-btn edit-btn" (click)="$event.stopPropagation(); openEditInvoiceModal(row)"
                        title="Edit Invoice">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                      </button>
                      <button class="action-btn delete-btn" (click)="$event.stopPropagation(); deleteInvoice(row)"
                        title="Delete Invoice">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="3 6 5 6 21 6"></polyline>
                          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                          </path>
                          <line x1="10" y1="11" x2="10" y2="17"></line>
                          <line x1="14" y1="11" x2="14" y2="17"></line>
                        </svg>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="expandedRowId === row.id" class="details-row">
                    <td colspan="8">
                      <div class="details-container">
                        <div class="details-grid">
                          <div class="detail-column summary">
                            <h4>Payment Summary</h4>
                            <div class="detail-row amount-paid-row">
                              <span class="label-strong">Amount Paid:</span>
                              <div style="display: flex; gap: 10px; align-items: center;">
                                <input type="number" [(ngModel)]="row.amountPaid" (change)="updateAmountPaid(row)"
                                  (click)="$event.stopPropagation()" class="partial-amount-input">
                                <span class="value-strong">(Remaining: {{ row.remainingBalance | currency }})</span>
                              </div>
                            </div>
                            <div class="status-actions">
                              <button (click)="updateInvoiceStatus(row, 'Paid'); $event.stopPropagation()"
                                class="status-btn paid" [class.active]="row.status === 'Paid'"
                                [disabled]="row.status === 'Canceled'">Paid</button>
                              <button (click)="updateInvoiceStatus(row, 'Partial'); $event.stopPropagation()"
                                class="status-btn partial" [class.active]="row.status === 'Partial'"
                                [disabled]="row.status === 'Canceled'">Partial</button>
                              <button (click)="updateInvoiceStatus(row, 'Not Paid'); $event.stopPropagation()"
                                class="status-btn not-paid" [class.active]="row.status === 'Not Paid'"
                                [disabled]="row.status === 'Canceled'">Not Paid</button>
                              <button
                                (click)="updateInvoiceStatus(row, row.status === 'Canceled' ? 'Not Paid' : 'Canceled'); $event.stopPropagation()"
                                class="status-btn cancel" [class.active]="row.status === 'Canceled'">
                                {{ row.status === 'Canceled' ? 'Uncancel' : 'Cancel' }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr *ngIf="filteredGridData.length === 0">
                  <td colspan="8" class="empty-state text-center">No sales invoices found.</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Items Tab -->
    <div *ngIf="activeTab === 'items'">
      <div class="toolbar-container" style="justify-content: flex-end;">
        <button class="action-btn save-btn" (click)="openAddItemModal()">+ Add Item</button>
      </div>
      <div class="data-grid-container" style="margin-top: 20px;">
        <div class="data-grid-scrollable">
          <table class="data-grid">
            <thead>
              <tr>
                <th>Item Name</th>
                <th class="text-right">Default Unit Price ($)</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="isLoadingItems">
                <td colspan="3" class="text-center loading-row">
                  <div class="loading-content">
                    <div class="spinner spinner-sm"></div>
                    <span>Loading items...</span>
                  </div>
                </td>
              </tr>
              <ng-container *ngIf="!isLoadingItems">
                <tr *ngFor="let item of templateItems" class="data-row">
                  <td>{{ item.name }}</td>
                  <td class="text-right">{{ item.defaultUnitPrice | currency }}</td>
                  <td class="company-actions text-center">
                    <button class="action-btn edit-btn" (click)="openEditItemModal(item)" title="Edit Item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                      </svg>
                    </button>
                    <button class="action-btn delete-btn" (click)="deleteTemplateItem(item)" title="Delete Item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="templateItems.length === 0">
                  <td colspan="3" class="empty-state text-center">No invoice items configured.</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Manual Invoice Add/Edit Modal -->
<div class="modal-overlay" *ngIf="isManualModalOpen" (click)="closeManualModal()">
  <div class="invoice-modal manual-modal" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>{{ isManualEditMode ? 'Edit' : 'Add' }} Sales Invoice</h2>
      <button class="close-btn-static" (click)="closeManualModal()">&times;</button>
    </div>

    <div class="invoice-body">
      <div class="form-row">
        <div class="form-group">
          <label>Invoice Date</label>
          <input type="date" [(ngModel)]="manualInvoiceData.invoiceDate" class="form-control">
        </div>
        <div class="form-group">
          <label>Company</label>
          <select [(ngModel)]="manualInvoiceData.companyId" class="form-control">
            <option value="" disabled selected>Select Company</option>
            <option *ngFor="let c of companies" [value]="c.id">{{ c.company }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Sender</label>
          <div style="display: flex; gap: 8px;">
            <select [(ngModel)]="manualInvoiceData.senderId" class="form-control" style="flex-grow: 1;">
              <option value="" disabled selected>Select Sender</option>
              <option *ngFor="let s of availableSenders" [value]="s.id">{{ s.company }}</option>
            </select>
            <button type="button" class="action-btn save-btn" (click)="openSenderSelectionModal()"
              style="padding: 0 12px;">+</button>

          </div>
        </div>
      </div>

      <div class="manual-content">
        <div *ngIf="selectedCompanyFedexNumber" style="margin-bottom: 12px; color: #334155; font-size: 0.95rem;">
          <strong>Fedex #:</strong> {{ selectedCompanyFedexNumber }}
        </div>

        <div class="manual-section-header">
          <h4 class="manual-section-title">Invoice Items</h4>
          <button class="action-btn view-btn" (click)="addInvoiceItem()">+ Add Item</button>
        </div>

        <table class="data-grid">
          <thead>
            <tr>
              <th>Item</th>
              <th style="width: 120px;">Quantity</th>
              <th style="width: 150px;">Unit Price ($)</th>
              <th class="text-right" style="width: 150px;">Amount ($)</th>
              <th class="col-delete"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of manualInvoiceData.items; let i = index">
              <td>
                <select [(ngModel)]="item.item" (change)="onItemSelectionChange(item)" class="table-input">
                  <option value="" disabled>Select Item</option>
                  <option *ngFor="let opt of templateItems" [value]="opt.name">{{ opt.name }}</option>
                </select>
              </td>
              <td><input type="number" [(ngModel)]="item.quantity" (ngModelChange)="calculateItemAmount(item)"
                  class="table-input"></td>
              <td><input type="number" [(ngModel)]="item.unitPrice" (ngModelChange)="calculateItemAmount(item)"
                  class="table-input"></td>
              <td class="text-right">{{ item.amount | currency }}</td>
              <td class="text-center">
                <button class="close-btn-static btn-remove" (click)="removeInvoiceItem(i)">&times;</button>
              </td>
            </tr>
            <tr *ngIf="manualInvoiceData.items.length === 0">
              <td colspan="5" class="text-center no-stores-msg">No items added.</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3" class="text-right" style="font-weight: bold;">Total Due:</td>
              <td class="text-right" style="font-weight: bold; color: #2563eb; font-size: 1.1rem;">{{
                manualInvoiceData.totalDue | currency }}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="invoice-footer"
      style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #e2e8f0; display: flex; justify-content: flex-end; gap: 10px;">
      <button class="action-btn btn-cancel-manual" (click)="closeManualModal()">Cancel</button>
      <button class="action-btn save-btn" style="display: flex; align-items: center; gap: 8px;"
        (click)="saveManualInvoice()"
        [disabled]="isLoadingGrid || !manualInvoiceData.companyId || manualInvoiceData.items.length === 0">
        <div *ngIf="isLoadingGrid" class="spinner spinner-sm"
          style="width: 14px; height: 14px; border: 2px solid #166534; border-top-color: transparent; margin: 0;"></div>
        <span>{{ isLoadingGrid ? 'Saving...' : 'Save Invoice' }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Add/Edit Item Modal -->
<div class="modal-overlay" *ngIf="isItemModalOpen" (click)="closeItemModal()">
  <div class="invoice-modal manual-modal" style="width: 500px;" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>{{ isItemEditMode ? 'Edit' : 'Add' }} Invoice Item</h2>
      <button class="close-btn-static" (click)="closeItemModal()">&times;</button>
    </div>
    <div class="invoice-body">
      <div class="form-row">
        <div class="form-group">
          <label>Item Name</label>
          <input type="text" [(ngModel)]="templateItemData.name" class="form-control">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Default Unit Price ($)</label>
          <input type="number" [(ngModel)]="templateItemData.defaultUnitPrice" class="form-control">
        </div>
      </div>
    </div>
    <div class="invoice-footer"
      style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #e2e8f0; display: flex; justify-content: flex-end; gap: 10px;">
      <button class="action-btn btn-cancel-manual" (click)="closeItemModal()">Cancel</button>
      <button class="action-btn save-btn" style="display: flex; align-items: center; gap: 8px;"
        (click)="saveTemplateItem()" [disabled]="isSavingItem || !templateItemData.name">
        <div *ngIf="isSavingItem" class="spinner spinner-sm"
          style="width: 14px; height: 14px; border: 2px solid #166534; border-top-color: transparent; margin: 0;"></div>
        <span>{{ isSavingItem ? 'Saving...' : 'Save Item' }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Hidden container for PDF generation -->
<div class="print-container">
  <div id="pdf-content" class="invoice-modal">
    <app-sales-invoice-template [invoice]="selectedInvoice" [forPdf]="true"></app-sales-invoice-template>
  </div>
</div>

<!-- Invoice Modal -->
<div class="modal-overlay" *ngIf="isInvoiceModalOpen" (click)="closeInvoiceModal()">
  <div class="invoice-modal" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Invoice {{ selectedInvoice?.invoiceNumber }}</h2>
      <div class="header-actions">
        <button class="action-btn view-btn" (click)="printInvoice(selectedInvoice)">Save to PDF</button>
        <button class="close-btn-static" (click)="closeInvoiceModal()">&times;</button>
      </div>
    </div>

    <app-sales-invoice-template [invoice]="selectedInvoice"></app-sales-invoice-template>
  </div>
</div>

<!-- Email Overlay/Form -->
<div class="modal-overlay overlay-z2000" *ngIf="isSavingPDFs">
  <div class="processing-box" style="background: white; padding: 30px; border-radius: 8px; text-align: center;">
    <div class="spinner spinner-mb"></div>
    <p class="processing-text">Processing PDF attachment...</p>
  </div>
</div>

<app-email-form *ngIf="isEmailModalOpen" [to]="emailData.to" [subject]="emailData.subject" [body]="emailData.body"
  [templateType]="'sales_invoice'" (emailSent)="onEmailSent($event)" (close)="closeEmailModal(true)"
  [attachments]="emailData.attachments"></app-email-form>

<!-- Sender Selection Modal -->
<div class="modal-overlay overlay-z2000" *ngIf="isSenderModalOpen" (click)="closeSenderSelectionModal()">
  <div class="invoice-modal manual-modal" style="width: 500px; max-height: 80vh; display: flex; flex-direction: column;"
    (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Select Sender Company</h2>
      <button class="close-btn-static" (click)="closeSenderSelectionModal()">&times;</button>
    </div>

    <div class="invoice-body" style="overflow-y: auto; padding: 20px;">
      <div class="form-group" style="margin-bottom: 15px;">
        <input type="text" [(ngModel)]="senderSearchQuery" placeholder="Search companies..." class="form-control"
          style="width: 100%;">
      </div>

      <div style="border: 1px solid #e2e8f0; border-radius: 6px; overflow: hidden;">
        <div *ngFor="let c of filteredSenderCompanies" (click)="toggleSenderSelection(c.id)"
          style="padding: 12px 15px; border-bottom: 1px solid #f1f5f9; cursor: pointer; transition: background 0.2s; display: flex; align-items: center;"
          onmouseover="this.style.backgroundColor='#f8fafc'" onmouseout="this.style.backgroundColor='transparent'">
          <input type="checkbox" [checked]="tempSelectedSenderIds.has(c.id)" (change)="toggleSenderSelection(c.id)"
            (click)="$event.stopPropagation()" style="margin-right: 12px; width: 16px; height: 16px; cursor: pointer;">
          <div>
            <div style="font-weight: 500; color: #1e293b;">{{ c.company }}</div>
            <div style="font-size: 0.8rem; color: #64748b; margin-top: 2px;" *ngIf="c.address">{{ c.address }}</div>
          </div>
        </div>
        <div *ngIf="filteredSenderCompanies.length === 0" style="padding: 20px; text-align: center; color: #64748b;">
          No companies found.
        </div>
      </div>

      <div style="margin-top: 20px; text-align: right; border-top: 1px solid #e2e8f0; padding-top: 15px;">
        <button class="action-btn btn-cancel-manual" (click)="closeSenderSelectionModal()"
          style="margin-right: 8px;">Cancel</button>
        <button class="action-btn save-btn" (click)="confirmSenderSelection()">Confirm Selection</button>
      </div>
    </div>
  </div>
</div>